import { ReviewSettingEdit } from './ReviewSettingEdit';
import ReviewSettingTemplateEdit from './ReviewSettingTemplateEdit';

export default {
    edit: ReviewSettingEdit,
    template: ReviewSettingTemplateEdit,
};
